module.exports = __webpack_public_path__ + "static/img/A00008939.55caaaf.55caaaf4.jpg";